import { render } from "./SnapshotInstance.vue?vue&type=template&id=46fe3e61"
import script from "./SnapshotInstance.vue?vue&type=script&lang=js"
export * from "./SnapshotInstance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__